import { Link } from "react-router-dom";
import { useQuery, gql } from "@apollo/client";

const SCHOOL_YEAR_OVERVIEW_QUERY = gql`
    query SchoolYearOverview {
        schoolYearOverview {
            holidays {
                id
                startDate
                endDate
                name
            }
        }
    }
`;

// Helper: format ISO date string to dd.mm.yyyy for display only
const formatDate = (isoDate) => {
    if (!isoDate) return '';
    const d = new Date(isoDate);
    const day = d.getDate().toString().padStart(2, '0');
    const month = (d.getMonth() + 1).toString().padStart(2, '0');
    const year = d.getFullYear();
    return `${day}.${month}.${year}`;
};


export default function HolidayManagement() {
    const { loading, error, data } = useQuery(SCHOOL_YEAR_OVERVIEW_QUERY);

    return (
        // The component now has no outer padding or margins.
        <div className="w-full">
            <header className="mb-6 flex flex-col sm:flex-row justify-between sm:items-center gap-4">
                <h1 className="text-3xl font-bold text-neutral-900">
                    Schulfreie Tage
                </h1>
                <Link
                    to="/admin/holidays/new"
                    className="mainBtn inline-flex items-center justify-center sm:w-auto w-full text-white px-5 py-2"
                >
                    <svg className="mr-2 h-5 w-5" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                        <path fillRule="evenodd" d="M10 3a1 1 0 011 1v5h5a1 1 0 110 2h-5v5a1 1 0 11-2 0v-5H4a1 1 0 110-2h5V4a1 1 0 011-1z" clipRule="evenodd" />
                    </svg>
                    <span>Hinzufügen</span>
                </Link>
            </header>
            <main>
                {loading && <div className="py-8 text-center">Lade schulfreie Tage...</div>}
                {error && <div className="py-8 text-center text-red-600">Fehler beim Laden der schulfreien Tage: {error.message}</div>}
                {data && data.schoolYearOverview.holidays.length > 0 ? (
                    <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 2xl:grid-cols-5 gap-6">
                        {data.schoolYearOverview.holidays.map((holiday, index) => (
                            <div key={holiday.id || index} className="wrap bg-white p-6 rounded-xl border-2 border-neutral-200 transition-all duration-100 hover:border-neutral-300">
                                <Link to={`/admin/holidays/${holiday.id}`} className="block">
                                    <h2 className="text-lg font-bold text-neutral-800">{holiday.name}</h2>
                                    <p className="text-sm text-neutral-600">
                                        {formatDate(holiday.startDate)} - {formatDate(holiday.endDate)}
                                    </p>
                                    <div className="mt-4 flex justify-end">
                                        <span className="text-sm text-blue-600 hover:underline">
                                            Bearbeiten →
                                        </span>
                                    </div>
                                </Link>
                            </div>
                        ))}
                    </div>
                ) : (
                    <div className="py-8 text-center text-neutral-600">Keine schulfreien Tage gefunden.</div>
                )}
            </main>
        </div>
    );
}